import DoubleLine from 'd3vue/components/DoubleLine.vue'
import { keepDimensions, valueAsNumber } from '../dataFilter'
import { toArray } from '../colors'
import api from '../api'

export default {
  id: 'double-line',
  label: 'Graphique en courbe (Mesure double)',
  component: DoubleLine,
  multipleMeasure: () => true,
  dimensions: 1,
  adaptater: (data, vue) => {
    const props = vue.metadata.measures.length > 1 ? {
      yKey: api.measure.name(vue.metadata.measures[0]),
      y2Key: api.measure.name(vue.metadata.measures[1]),
      y2Title: api.measure.unit(vue.metadata.measures[1]),
      y2Formatter: vue.buildMeasureFormatter(api.measure.uniqueName(vue.metadata.measures[1]))
    } : {}
    if (vue.colorScheme) {
      const colors = toArray(vue.colorScheme)
      props.color1 = colors[0]
      props.color2 = colors[colors.length - 1]
    }
    vue.buildProps(props)
    return keepDimensions(1, data).map(d => {
      const r = {}
      Object.keys(d).forEach(k => {
        r[k] = d[k]
      })
      vue.measure.forEach(m => {
        r[api.measure.name(m)] = valueAsNumber(r[api.measure.name(m)])
      })
      return r
    }).filter(d => !vue.noEmpty || vue.measure.map(m => {
      return d[api.measure.name(m)]
    }).reduce((a, b) => a + b, 0))
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/DoubleLine.js